module.exports = __webpack_public_path__ + "img/eg-6.99097334.jpg";